import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const samConfigurationSliceName = "samConfiguration";

export interface SamConfigurationState {
  selectedIDColorEntries: string[];
}

const initialState: SamConfigurationState = {
  selectedIDColorEntries: [],
};

const samSlice = createSlice({
  name: samConfigurationSliceName,
  initialState,
  reducers: {
    setConfigurationSelectedIDColorEntries(state: SamConfigurationState, action: PayloadAction<string[]>) {
      state.selectedIDColorEntries = action.payload;
    },
    resetConfigurationSelectedIDColorEntries(state: SamConfigurationState) {
      state.selectedIDColorEntries = [];
    },
  },
});

export interface SamConfigurationRootState {
  [samConfigurationSliceName]: SamConfigurationState;
}

export const selectSamConfiguration = (state: SamConfigurationRootState) => state[samConfigurationSliceName];
export const selectSamConfigurationSelectedIDColorEntries = (state: SamConfigurationRootState) => selectSamConfiguration(state).selectedIDColorEntries;

export const { setConfigurationSelectedIDColorEntries, resetConfigurationSelectedIDColorEntries } = samSlice.actions;
export const samConfigurationReducer = samSlice.reducer;
